import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import OfficialDoc from '@/types/table/officialDoc';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface OfficialDocData extends OfficialDoc {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class OfficialDocController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<OfficialDocData>>(
      API_CONTEXT + '/upms/officialDoc/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<OfficialDocData>(API_CONTEXT + '/upms/officialDoc/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/officialDoc/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/officialDoc/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/officialDoc/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/officialDoc/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/officialDoc/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/officialDoc/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/officialDoc/deleteBatch', params, httpOptions);
  }
  static startOnlyOfficialFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/officialDoc/startOnly/officialFlow',
      params,
      httpOptions,
    );
  }
  static startWithBusinessKeyOfficialFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/officialDoc/startWithBusinessKey/officialFlow',
      params,
      httpOptions,
    );
  }
  static startAndTakeUserTaskOfficialFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/officialDoc/startAndTakeUserTask/officialFlow',
      params,
      httpOptions,
    );
  }
  static startAndSaveDraftOfficialFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/officialDoc/startAndSaveDraft/officialFlow',
      params,
      httpOptions,
    );
  }
  static submitUserTaskOfficialFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/officialDoc/submitUserTask/officialFlow',
      params,
      httpOptions,
    );
  }
  static viewTaskBusinessDataOfficialFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(
      API_CONTEXT + '/upms/officialDoc/viewTaskBusinessData/officialFlow',
      params,
      httpOptions,
    );
  }
  static viewHistoricTaskBusinessDataOfficialFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(
      API_CONTEXT + '/upms/officialDoc/viewHistoricTaskBusinessData/officialFlow',
      params,
      httpOptions,
    );
  }
  static listWorkOrderOfficialFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/officialDoc/listWorkOrder/officialFlow',
      params,
      httpOptions,
    );
  }
  static send(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/officialDoc/send', params, httpOptions);
  }
}
